import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationService } from '../../services/configuration.service';
import { ItemFormat } from '../../models/lookups/itemFormat.model';

@Injectable({
  providedIn: 'root'
})
export class ItemFormatService {

  constructor(protected http: HttpClient,
    protected configurations: ConfigurationService) {
  }

  save(itemFormat: ItemFormat) {
    return this.http.post(this.configurations.apiAddress + "/api/ItemFormat/save", itemFormat);
  }

  search(searchText: string) {
    let myParams = new HttpParams()
      .set('searchText', searchText == undefined ? "" : searchText)
    return this.http.get(this.configurations.apiAddress + '/api/ItemFormat/search', { params: myParams });
  }

  delete(id: number) {
    return this.http.delete(this.configurations.apiAddress + '/api/ItemFormat/delete/' + id);
  }

  getById(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/ItemFormat/getById/' + id);
  }

  getAll() {
    return this.http.get(this.configurations.apiAddress + '/api/ItemFormat/getAll/');
  }
}
